import React, { Fragment, useEffect, useRef, useState } from 'react'
import { Link } from "react-router-dom"
import { useDispatch, useSelector } from 'react-redux'
import Img2 from "../images/support.png"
import { toast } from "react-toastify"
import { clearErrors, ContactAction } from '../../redux/actions/userActions'
import { CONTACT_RESET } from '../../redux/constants/userConstant'

const Support = ({ showSupport, setShowSupport }) => {


    const dispatch = useDispatch()

    const wrapperRef = useRef(null);



    const { loading, error, message: successMessage } = useSelector(state => state.contactUs)

    const [name, setName] = useState("")
    const [email, setEmail] = useState("")
    const [phone, setPhone] = useState("")
    const [message, setMessage] = useState("")

    const getToastStyle = (color) => ({
        background: document.documentElement.classList.contains("dark") ? "#111827" : "#fff",
        color,
        border: document.documentElement.classList.contains("dark") ? "1px solid #243044" : "1px solid rgba(0,0,0,0.05)",
        padding: "6px 20px",
        borderRadius: "30px",
        fontSize: "16px",
        width: "auto",
        maxWidth: "fit-content",
        display: "flex",
    });

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                wrapperRef.current &&
                !wrapperRef.current.contains(e.target)
            ) {
                setShowSupport(false)
            }
        }

        document.addEventListener("mousedown", handleClickOutside)

        return () => {
            document.removeEventListener("mousedown", handleClickOutside)
        }


    }, [setShowSupport])



    const handleSubmit = (e) => {
        e.preventDefault();


        if (!name) return toast.error("Please enter your name", {
            position: "bottom-center",
            style: getToastStyle("#DB2426"),
        });
        if (!email) return toast.error("Please enter your email", {
            position: "bottom-center",
            style: getToastStyle("#DB2426"),
        });
        if (!message) return toast.error("Please enter your message", {
            position: "bottom-center",
            style: getToastStyle("#DB2426"),
        });


        dispatch(ContactAction({ name, email, message, phone }))


    }



    useEffect(() => {
        if (successMessage) {
            toast.success(successMessage, {
                position: "bottom-center",
                style: getToastStyle("#17910f"),
            });
            setName("")
            setEmail("")
            setPhone("")
            setMessage("")
            dispatch({ type: CONTACT_RESET })
            setShowSupport(false)
        }

        if (error) {
            toast.error(error, {
                position: "bottom-center",
                style: getToastStyle("#DB2426"),
            })
            dispatch(clearErrors())
        }
    }, [successMessage, error, dispatch, setShowSupport])



    return (
        <Fragment>
            {/* Overlay for Background Blur when support is open */}
            <div className={`fixed inset-0 bg-black/20 backdrop-blur-[2px] z-[99999998] transition-opacity duration-300 ${showSupport ? "opacity-100" : "opacity-0 pointer-events-none"}`} onClick={() => setShowSupport(false)}></div>

            {/* Support Drawer */}
            <div className={`fixed top-0 right-0 w-[85%] md:w-[40vmax] lg:w-[28vmax] bg-gray-50 dark:bg-slate-950 shadow-2xl my-scroll border-l border-white/50 dark:border-slate-800 min-h-screen h-screen max-h-screen overflow-y-auto z-[99999999] transition-transform duration-500 ease-out flex flex-col
                    ${showSupport ? "translate-x-0" : "translate-x-full"}
                    `}>

                {/* Modern Header */}
                <div className="px-[1.5vmax] py-[1.2vmax] flex justify-between items-center bg-white dark:bg-slate-950 sticky top-0 left-0 z-[100] shadow-sm border-b border-gray-100 dark:border-slate-800">
                    <div className="flex gap-[1vmax] items-center">
                        <div className="w-[3.5vmax] h-[3.5vmax] rounded-2xl bg-gradient-to-br from-indigo-500 to-blue-600 flex-center shadow-lg shadow-indigo-100">
                            <i className="fa-solid fa-headset text-[1.8vmax] text-white"></i>
                        </div>
                        <div>
                            <h3 className='font-bold text-[1.3vmax] lg:text-[1.1vmax] text-gray-800 dark:text-slate-100' >Support Center</h3>
                            <p className='text-[0.8vmax] text-green-500 font-bold flex items-center gap-1'>
                                <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
                                Online & Ready to help
                            </p>
                        </div>
                    </div>
                    <button
                        className='w-10 h-10 flex-center rounded-xl bg-gray-50 dark:bg-slate-900 text-gray-400 dark:text-slate-400 hover:bg-red-50 dark:hover:bg-red-500/15 hover:text-red-500 transition-all active:scale-90 border border-gray-100 dark:border-slate-700'
                        onClick={() => setShowSupport(false)}
                    >
                        <i className="fa-solid fa-xmark text-lg"></i>
                    </button>
                </div>

                <div className="flex-1 p-[1.5vmax] flex flex-col gap-[1.5vmax]" ref={wrapperRef}>

                    {/* Illustration Section */}
                    <div className="bg-white dark:bg-slate-900 rounded-3xl p-[2vmax] border border-gray-100 dark:border-slate-800 shadow-sm overflow-hidden relative group">
                        <div className="absolute top-0 right-0 w-32 h-32 bg-indigo-50 dark:bg-indigo-500/10 rounded-full blur-3xl -mr-16 -mt-16 group-hover:bg-indigo-100 dark:group-hover:bg-indigo-500/20 transition-colors"></div>
                        <div className="flex-center flex-col text-center relative z-10">
                            <img src={Img2} alt="Support Illustration" className='w-[60%] lg:w-[50%] mb-4 drop-shadow-xl animate-float' />
                            <h4 className="text-[1.2vmax] font-bold text-gray-800 dark:text-slate-100">How can we assist you?</h4>
                            <p className="text-[0.85vmax] text-gray-500 dark:text-slate-400 px-4">Our dedicated team is here to provide you with the best experience.</p>
                        </div>
                    </div>

                    {/* Quick Contact Cards */}
                    <div className="space-y-[1vmax]">
                        {/* WhatsApp Card */}
                        <Link to="https://wa.me/+923004166107" target="_blank" className="flex items-center gap-[1.2vmax] bg-white dark:bg-slate-900 p-[1.2vmax] rounded-2xl shadow-sm border border-gray-100 dark:border-slate-800 hover:border-green-200 dark:hover:border-green-500/40 hover:shadow-md hover:shadow-green-50/50 dark:hover:shadow-black/20 transition-all group">
                            <div className="w-[4vmax] h-[4vmax] rounded-xl bg-green-50 text-green-600 flex-center transition-transform group-hover:scale-110">
                                <i className="fa-brands fa-whatsapp text-[2.2vmax]"></i>
                            </div>
                            <div className="flex-1">
                                <h3 className='text-[1.1vmax] font-bold text-gray-800 dark:text-slate-100' >WhatsApp Chat</h3>
                                <p className='text-[0.8vmax] font-medium text-gray-500 dark:text-slate-400'>Instant support & queries</p>
                                <p className='text-green-600 text-[0.85vmax] font-bold mt-1'>+92 312 0479504 </p>
                            </div>
                            <div className="w-8 h-8 rounded-full bg-gray-50 text-gray-400 flex-center group-hover:bg-green-600 group-hover:text-white transition-all">
                                <i className="fa-solid fa-chevron-right text-xs"></i>
                            </div>
                        </Link>

                        {/* Email Card */}
                        <Link to="mailto:zonifypro@gmail.com" target="_blank" className="flex items-center gap-[1.2vmax] bg-white dark:bg-slate-900 p-[1.2vmax] rounded-2xl shadow-sm border border-gray-100 dark:border-slate-800 hover:border-indigo-200 dark:hover:border-indigo-500/40 hover:shadow-md hover:shadow-indigo-50/50 dark:hover:shadow-black/20 transition-all group">
                            <div className="w-[4vmax] h-[4vmax] rounded-xl bg-indigo-50 text-indigo-600 flex-center transition-transform group-hover:scale-110">
                                <i className="fa-regular fa-envelope text-[2vmax]"></i>
                            </div>
                            <div className="flex-1">
                                <h3 className='text-[1.1vmax] font-bold text-gray-800 dark:text-slate-100' >Email Inquiry</h3>
                                <p className='text-[0.8vmax] font-medium text-gray-500 dark:text-slate-400'>Send us your detailed feedback</p>
                                <p className='text-indigo-600 text-[0.85vmax] font-bold mt-1'>zonifypro@gmail.com</p>
                            </div>
                            <div className="w-8 h-8 rounded-full bg-gray-50 text-gray-400 flex-center group-hover:bg-indigo-600 group-hover:text-white transition-all">
                                <i className="fa-solid fa-chevron-right text-xs"></i>
                            </div>
                        </Link>
                    </div>

                    {/* Message Form */}
                    <div className="bg-white dark:bg-slate-900 p-[2vmax] rounded-3xl shadow-sm border border-gray-100 dark:border-slate-800 mb-[5vmax]">
                        <div className="mb-6">
                            <h3 className='text-[1.2vmax] font-bold text-gray-800 dark:text-slate-100 mb-1' >Send us a Message</h3>
                            <p className='text-[0.85vmax] text-gray-500 dark:text-slate-400'>We usually respond within a few hours.</p>
                        </div>

                        <form className="space-y-[1.2vmax] relative" onSubmit={handleSubmit} >
                            {loading && (
                                <div className="absolute inset-0 bg-white/60 dark:bg-slate-950/60 backdrop-blur-[1px] z-[99] rounded-2xl flex-center">
                                    <div className="w-10 h-10 border-[3px] border-indigo-100 border-t-indigo-600 rounded-full animate-spin"></div>
                                </div>
                            )}

                            <div className='flex flex-col gap-1.5'>
                                <label className='text-[0.85vmax] font-bold text-gray-600 ml-1'>Your Name</label>
                                <div className="relative group">
                                    <i className="fa-regular fa-user absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 transition-colors group-focus-within:text-indigo-600"></i>
                                    <input
                                        type="text"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        className='w-full bg-gray-50 pl-12 pr-4 py-3 rounded-xl border border-gray-200 outline-none focus:bg-white focus:border-indigo-500 focus:ring-4 focus:ring-indigo-50 transition-all text-[0.9vmax] font-medium text-gray-700'
                                        placeholder='Enter full name'
                                    />
                                </div>
                            </div>

                            <div className='flex flex-col gap-1.5'>
                                <label className='text-[0.85vmax] font-bold text-gray-600 ml-1'>Email Address</label>
                                <div className="relative group">
                                    <i className="fa-regular fa-envelope absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 transition-colors group-focus-within:text-indigo-600"></i>
                                    <input
                                        type="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        className='w-full bg-gray-50 pl-12 pr-4 py-3 rounded-xl border border-gray-200 outline-none focus:bg-white focus:border-indigo-500 focus:ring-4 focus:ring-indigo-50 transition-all text-[0.9vmax] font-medium text-gray-700'
                                        placeholder='name@example.com'
                                    />
                                </div>
                            </div>

                            <div className='flex flex-col gap-1.5'>
                                <label className='text-[0.85vmax] font-bold text-gray-600 ml-1'>Phone Number</label>
                                <div className="relative group">
                                    <i className="fa-solid fa-phone absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 transition-colors group-focus-within:text-indigo-600"></i>
                                    <input
                                        type="tel"
                                        value={phone}
                                        onChange={(e) => setPhone(e.target.value)}
                                        className='w-full bg-gray-50 pl-12 pr-4 py-3 rounded-xl border border-gray-200 outline-none focus:bg-white focus:border-indigo-500 focus:ring-4 focus:ring-indigo-50 transition-all text-[0.9vmax] font-medium text-gray-700'
                                        placeholder='Enter phone number'
                                    />
                                </div>
                            </div>

                            <div className='flex flex-col gap-1.5'>
                                <label className='text-[0.85vmax] font-bold text-gray-600 ml-1'>How can we help?</label>
                                <textarea
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    className='w-full bg-gray-50 px-4 py-3 rounded-xl border border-gray-200 outline-none focus:bg-white focus:border-indigo-500 focus:ring-4 focus:ring-indigo-50 transition-all text-[0.9vmax] font-medium text-gray-700'
                                    placeholder='Tell us what you need...'
                                    rows={5}
                                />
                            </div>

                            <button className='w-full bg-gradient-to-r from-indigo-600 to-blue-600 text-white rounded-xl py-3.5 font-bold text-[1vmax] flex items-center justify-center gap-3 shadow-lg shadow-indigo-100 hover:shadow-indigo-200 transition-all hover:scale-[1.02] active:scale-[0.98]'
                                type='submit'
                            >
                                <i className="fa-regular fa-paper-plane"></i>
                                Send Message
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Support
